module.exports = __webpack_public_path__ + "static/media/recommendedb2.fbb2c7fb.png";